import { render, staticRenderFns } from "./Searcher.vue?vue&type=template&id=63fa3a72"
import script from "./Searcher.vue?vue&type=script&lang=js"
export * from "./Searcher.vue?vue&type=script&lang=js"
import style0 from "./Searcher.vue?vue&type=style&index=0&id=63fa3a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports